
import React from 'react';
import { Card } from "@/components/ui/card";
import { FileText, BookMarked, Clock, Users } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { StudyNote } from "@/types/notes";
import { useIsMobile } from '@/hooks/use-mobile';

interface StatsCardsProps {
  notes: StudyNote[];
  categories: string[];
  isAdmin: boolean;
}

export const StatsCards: React.FC<StatsCardsProps> = ({ notes, categories, isAdmin }) => {
  const { isMobile } = useIsMobile();
  
  const totalNotes = notes.length;
  const totalCategories = categories.length - 1; // Subtract 'all' category
  const recentlyAdded = notes.slice(0, 3).length;
  
  // Use a more efficient layout for mobile
  return (
    <div className="grid grid-cols-2 gap-2">
      <Card className="bg-gradient-to-br from-purple-50 to-secondary/5 border-none shadow-sm">
        <div className="p-2">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-[10px] font-medium text-gray-500">Total Notes</p>
              <p className="text-sm font-bold text-secondary mt-0.5">{totalNotes}</p>
            </div>
            <div className="p-1.5 rounded-full bg-secondary/10">
              <FileText className="h-3 w-3 text-secondary" />
            </div>
          </div>
          <Progress value={totalNotes > 0 ? 100 : 0} className="mt-1.5 h-1 bg-secondary/20" />
        </div>
      </Card>

      <Card className="bg-gradient-to-br from-blue-50 to-blue-500/5 border-none shadow-sm">
        <div className="p-2">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-[10px] font-medium text-gray-500">Categories</p>
              <p className="text-sm font-bold text-blue-600 mt-0.5">{totalCategories}</p>
            </div>
            <div className="p-1.5 rounded-full bg-blue-100">
              <BookMarked className="h-3 w-3 text-blue-600" />
            </div>
          </div>
          <Progress value={(totalCategories) * 10} className="mt-1.5 h-1 bg-blue-200" />
        </div>
      </Card>
    </div>
  );
};
